var Backbone = bookedby.deps != null ? bookedby.deps.Backbone : global.Backbone;

var EmployeeModel = Backbone.Epoxy.Model.extend({

  computeds: {

    showDurations: function() {
      return bookedby.app.staticData && bookedby.app.staticData.storeSettings &&
        bookedby.app.staticData.storeSettings.showDurations;
    },

    durationValue: function() {

      var addGap = this.get('isLastService') !== true;
      var duration = this.get('duration');
      if (addGap) {
        duration += this.get('afterDuration')
      }
      return duration / 60;
    }
  }

});

module.exports = EmployeeModel;